import { resolvePersistedReportWindow, type SafetyScanTimeWindow } from '../../domain/acceptance/safetyScanReportContext';
import { firstDefinedString, firstStringFromPaths } from './workspaceUtils';

const FROM_PATHS = [
  'proof_scope.start_ts',
  'case_file.proof_scope.start_ts',
  'manifest.from_date',
  'manifest.filters.from_date',
  'manifest.scope.from_date',
  'evidence_pack.from_date',
  'evidence_pack.proof_scope.start_ts',
];

const TO_PATHS = [
  'proof_scope.end_ts',
  'case_file.proof_scope.end_ts',
  'manifest.to_date',
  'manifest.filters.to_date',
  'manifest.scope.to_date',
  'evidence_pack.to_date',
  'evidence_pack.proof_scope.end_ts',
];

export function resolveCanonicalProofWindow(args: {
  persistedReport?: unknown;
  queueWindow?: { start?: string | null; end?: string | null } | null;
  reportFrom?: string | null;
  reportTo?: string | null;
  searchParams: URLSearchParams;
  reportData?: unknown;
  proofPackPreviewData?: unknown;
  workspaceFromDate?: string | null;
  workspaceToDate?: string | null;
}): SafetyScanTimeWindow {
  return resolvePersistedReportWindow({
    persistedReport: args.persistedReport,
    queueWindow: args.queueWindow,
    urlStart: firstDefinedString(
      args.reportFrom,
      args.searchParams.get('report_from'),
      args.searchParams.get('from_date'),
      args.searchParams.get('from'),
      firstStringFromPaths(args.reportData, ['filters.from_date']),
      firstStringFromPaths(args.proofPackPreviewData, FROM_PATHS),
      args.workspaceFromDate,
    ),
    urlEnd: firstDefinedString(
      args.reportTo,
      args.searchParams.get('report_to'),
      args.searchParams.get('to_date'),
      args.searchParams.get('to'),
      firstStringFromPaths(args.reportData, ['filters.to_date']),
      firstStringFromPaths(args.proofPackPreviewData, TO_PATHS),
      args.workspaceToDate,
    ),
  });
}
